module.exports = __webpack_public_path__ + "common/icon-fullcolor-c634b9c8b3c7a01792f9a09cbc803172.svg";